export class News {
  id: number;
  title: string;
  datePub: Date;
  message: string;
  filePath: string;
  fileExt: string;
  enabled: boolean;
}
